import API from './API';

export default {
  getEmployee(employeeId) {
    return API.get(`/employee/?filter=id||$eq||${employeeId}`)
  },
  
  getPartnerByHeadquarter(headquarterId) {

      return API.get(`/headquarter?filter=id||$eq||${headquarterId}&`,{
        params: {
             join: [
              'partner',
            ], 
          },
        });
  },

  updEmployee(employee) {
    return API.patch('/employee/' + employee.id, employee)
  },

  // Employee con le sue sedi (e relativo partner) — per la sezione "Le mie Sedi".
  getEmployeeWithHeadquarters(employeeId) {
    return API.get(`/employee?filter=id||$eq||${employeeId}&`, {
      params: {
        join: ['headquarters', 'headquarters.partner'],
      },
    });
  },

  // Sedi selezionabili: quelle del partner, o tutte se il partner non è noto
  // (employee senza sedi: il legame col partner passa solo dalle sedi).
  getAvailableHeadquarters(partnerId) {
    if (partnerId) {
      return API.get(`/headquarter?filter=partner.id||$eq||${partnerId}&`, {
        params: { join: ['partner'] },
      });
    }
    return API.get('/headquarter');
  },

  // Associa una sede all'employee (self-service dal profilo).
  addHeadquarter(employeeId, headquarter) {
    return API.post('/employee/add-headquarter', {
      id: employeeId,
      headquarter,
    });
  },

  // Crea una NUOVA sede (associata al partner via `partner: { id }`).
  createHeadquarter(headquarter) {
    return API.post('/headquarter', headquarter);
  },

  updPassword(password_obj) {
    return API.post('/auth/update-password' ,password_obj)
  },
};